import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import LoadingSpinner from 'components/loading/LoadingSpinner';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import styled from 'styled-components';
import { mediaMSmMax } from 'helpers/breakpoints';
import { useBreakpoint } from '../BreakpointProvider';
import { dollarsNoCentsWithSymbol } from '../../helpers/currency';
import { useEstimatedEarningsQuery } from '../blw/hooks';

export const RenderTooltip = ({ distance = null }) => (
  <span>
    <Tooltip
      place="top"
      triggerWith={
        <svg height={18} xmlns="http://www.w3.org/2000/svg" fill="#0e7873" viewBox="0 0 1008 1008">
          <path d="M504 980.2C239.9 980.2 27.8 768.1 27.8 504S239.9 27.8 504 27.8 980.2 239.9 980.2 504 768.1 980.2 504 980.2zm0-887.4C274.6 92.8 92.8 274.6 92.8 504S274.6 915.2 504 915.2 915.2 733.4 915.2 504 733.4 92.8 504 92.8zm34.6 467.5v30.3c0 17.3-13 34.6-34.6 34.6s-34.6-13-34.6-34.6v-51.9c0-13 4.3-21.6 13-26h4.3l34.6-17.3h8.7c4.3 0 8.7-4.3 8.7-4.3 43.3-17.3 56.3-34.6 56.3-73.6 0-51.9-43.3-90.9-95.2-90.9-43.3 0-82.2 30.3-95.2 69.3 0 8.7-17.3 21.6-34.6 17.3-17.3-8.7-26-26-21.6-43.3C365.7 300.6 430.6 253 504.2 253c90.9 0 160.2 69.3 160.2 155.8 0 69.3-30.3 108.2-95.2 134.2-4.3 0-8.7 4.3-13 4.3h-8.6c-4.6 8.6-9 8.6-9 13zM504 755.1c-21.6 0-39-17.3-39-39s17.3-39 39-39 39 17.3 39 39-17.4 39-39 39z" />
        </svg>
      }
      distance={distance}
      trigger="mouseenter"
      className="reeetupo"
    >
      <div>
        <div className="Grid">
          <div className="Grid-cell">
            <div className="u-textGrayMedium u-textLeft u-sm-fsXxs u-fsSm">
              These earnings assume eight <br /> 8-hour trips per month.
            </div>
          </div>
        </div>
      </div>
    </Tooltip>
  </span>
);

const FormFooter = (props) => {
  const { valuesMissing, hasSubmitted, setHasSubmitted, formSubmitted } = props;

  const breakpoints = useBreakpoint();
  const smallScreen = breakpoints.xs || breakpoints.sm;

  const { formState, getValues } = useFormContext();
  const { isSubmitting } = formState;

  const hasErrors = valuesMissing() && hasSubmitted;

  const { data: { data: estimatedEarningsQuery } = {} } = useEstimatedEarningsQuery({
    state: getValues().state,
    longitude: getValues().lng,
    latitude: getValues().lat,
    boatModel: getValues().boat_model,
    make: getValues().make,
    countryCode: getValues().country_code,
    yearManufactured: getValues().year_manufactured,
  });

  useEffect(() => {
    if (hasErrors && smallScreen) {
      document.body.classList.add('tooltip-mobile-error');
    } else {
      document.body.classList.remove('tooltip-mobile-error');
    }
    return () => {
      document.body.classList.remove('tooltip-mobile-error');
    };
  }, [hasErrors, smallScreen]);

  const priceWrapper = (sticky) => (
    <div className={`${sticky ? 'u-sm-mt1' : 'FormFooter-priceWrapper u-sm-mt1'}  u-sm-mb0 Grid-cell u-size1of2`}>
      <div className="u-flex u-sm-pr0">
        <p className="u-fsSm u-mr05">
          Estimated monthly <br /> earnings:
          <span className="u-textOwners u-textBold">
            {' '}
            {/* @ts-ignore */}
            {dollarsNoCentsWithSymbol(estimatedEarningsQuery?.estimated_earnings || 0)}
          </span>
        </p>
        <RenderTooltip />
      </div>
    </div>
  );

  return (
    <div>
      <Wrapper className="FormFooter ">
        <div className="Grid Grid--alignMiddle">
          {priceWrapper(false)}
          <div className="FormFooter-buttonWrapper Grid-cell u-size1of2">
            <button
              type="submit"
              data-testid="component-formFooter-submit-button"
              disabled={isSubmitting || formSubmitted}
              onClick={() => {
                setHasSubmitted(true);
              }}
              className={`Button Button--yellow u-textBold u-textUpper u-fsSm u-sizeFull Button--large u-posRelative ${
                isSubmitting ? 'is-loading' : ''
              }`}
            >
              {isSubmitting ? (
                <LoadingSpinner addSeparator bg={false} />
              ) : (
                <span>{smallScreen ? 'Continue' : 'Get Started'}</span>
              )}
            </button>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

const Wrapper = styled.div`
  padding: 2.5em 0 0 0;
  ${mediaMSmMax} {
    padding: 1em 0;

    .FormFooter-buttonWrapper {
      margin-top: 1em;
    }
  }
`;

export default FormFooter;
